import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import SpotlightSearch from "@/components/SpotlightSearch";
import InstallPWA from "@/components/InstallPWA";
import { Toaster } from "sonner";

export default function AppLayout() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  // Auto-close the mobile drawer on every route change so tapping a nav link
  // reveals the destination instead of leaving the drawer stuck open.
  useEffect(() => { setMobileNavOpen(false); }, [location.pathname]);

  useEffect(() => {
    function onKey(e) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setSearchOpen((v) => !v);
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="min-h-screen flex bg-background noise text-foreground">
      <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
      {mobileNavOpen && (
        <button
          type="button"
          aria-label="Close menu"
          onClick={() => setMobileNavOpen(false)}
          className="md:hidden fixed inset-0 z-20 bg-black/60 backdrop-blur-sm"
          data-testid="mobile-nav-backdrop"
        />
      )}
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onOpenSearch={() => setSearchOpen(true)} onOpenMobileNav={() => setMobileNavOpen(true)} />
        <main className="flex-1 relative overflow-x-hidden">
          <div className="px-4 sm:px-6 md:px-8 py-6 md:py-10 max-w-[1440px] w-full" data-testid="main-content">
            <Outlet />
          </div>
        </main>
      </div>
      <SpotlightSearch open={searchOpen} onClose={() => setSearchOpen(false)} />
      <InstallPWA />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
